import styled from 'styled-components';
import _ from 'lodash';
import ReactPlayer from 'react-player';
import { NEXT_DAILYMOTION_ID } from 'src/constants';
import CardVideoFull from '../components/card-video-full';

export const useVideoIframe = _data => {
  if (_.isEmpty(_data)) return null;

  switch (_data?.type_video) {
    case '1': // dailymotion
      return (
        <>
          {/* <script src={`${NEXT_DAILYMOTION_ID}`}></script> */}
          {/* <ResolutionWrapper
            id={`dailymotion-${_data?.video_src}`}
            className='resolution-dailymotion'
            dangerouslySetInnerHTML={{
              __html: `
                <script
                type='text/javascript'
                src='${NEXT_DAILYMOTION_ID}'
                data-video=${_data?.video_src}
                ></script>`
            }}
          /> */}
          <ResolutionWrapper id={`dailymotion-${_data?.video_src}`} className='resolution-dailymotion'>
            <iframe src={`https://www.dailymotion.com/embed/video/${_data?.video_src}?autoplay=0`} frameborder='0'></iframe>
          </ResolutionWrapper>
        </>
      );
    case '2':
    case '3': // youtube
      return (
        <ResolutionWrapper className='resolution-video'>
          <ReactPlayer width='100%' height='100%' loop={true} playing={false} muted={true} url={`${_data?.video_src}`} />
        </ResolutionWrapper>
      );
    case '4':
      return (
        <ResolutionWrapper className='resolution-video'>
          <div
            dangerouslySetInnerHTML={{
              __html: _data?.video_src
            }}
          />
        </ResolutionWrapper>
      );
    default: // default
      return (
        <ResolutionWrapper className='resolution-video'>
          <CardVideoFull data={_data} />
        </ResolutionWrapper>
      );
  }
};

const ResolutionWrapper = styled.div`
  &.resolution-dailymotion {
    position: relative;
    width: 100%;
    height: 100%;
    padding-top: 52.25%;
    &:before {
      content: '';
      /* background-color: #f1f1f1; */
      border-radius: 10px;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;

      padding-top: 52.25%;
    }

    .dailymotion-player-root {
      background-color: #e4e4e4;
      border-radius: 10px;
      position: unset !important;
      padding-bottom: unset !important;

      .dailymotion-player-wrapper {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
    iframe {

      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 10px;
    }
  }

  &.resolution-video {
    & > div {
      width: 100%;
      height: 100%;
      position: relative;
      padding-top: 52.25%;
      border-radius: 10px;
    }
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 10px;
    }
  }
  &.resolution-image {
    position: relative;
    padding-top: 0;
    overflow: hidden;
  }
`;

export default useVideoIframe;
